import React, { useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import useDocload from "../Hooks/useDocload";
import Document from "../components/Document";

const Docload = () => {
  const { policyType } = useParams();
  const { doc, loading, error } = useDocload(policyType);

  if(loading){
    
    return (
        <div className="mx-auto md:px-8 w-full min-h-full"> Loading </div>
    );
  }
  if (error) return <p>Error: {error}</p>;
   if (!doc) {
    return <Navigate to="/" replace />;
  }
  return (
   <div>
    <Document docHeader={doc.title} docBody={doc.content} />
   </div>
  );
}
export default Docload;